import { ColumnFormat } from 'components/search/PowerQueriesPage/types';

export const MOCK_HEADERS = [
  {
    key: 'uriPath',
    title: 'uriPath',
    dataKey: 'uriPath',
    width: 160,
    format: ColumnFormat.STRING,
  },
  {
    key: 'requests',
    title: 'requests',
    dataKey: 'requests',
    width: 80,
    format: ColumnFormat.NUMBER,
  },
  {
    key: 'errors',
    title: 'errors',
    dataKey: 'errors',
    width: 80,
    format: ColumnFormat.NUMBER,
  },
  {
    key: 'rate',
    title: 'rate',
    dataKey: 'rate',
    width: 80,
    format: ColumnFormat.NUMBER,
  },
];

export const MOCK_ROW_VALUES = [
  {
    id: '0',
    uriPath: 'invoiceGen2',
    requests: '848',
    errors: '848',
    rate: '100.00',
  },
  {
    id: '1',
    uriPath: 'sendgridWrapper',
    requests: '1786',
    errors: '511',
    rate: '28.61',
  },
  {
    id: '2',
    uriPath: 'pdfConverter',
    requests: '3400',
    errors: '420',
    rate: '12.35',
  },
  {
    id: '3',
    uriPath: 'invoiceGen1',
    requests: '124',
    errors: '12',
    rate: '9.68',
  },
  {
    id: '4',
    uriPath: 'histogramBuilder',
    requests: '1786',
    errors: '128',
    rate: '7.17',
  },
];

export const MIN_COL_WIDTH = 80; // minimum column width in pixels
export const MAX_COL_WIDTH = 1000; // maximum column width in pixels

// The number was thoroughly tested for 100 different strings:
// https://scalyr.myjetbrains.com/youtrack/issue/FRONT-5494#focus=Comments-4-37818.0-0.
export const LEFT_AND_RIGHT_PADDINGS = 31;

export const AVERAGE_NUMBER_OF_ROWS = 50; //  we assume that check first 50 rows in column is enough to get the maximum column length
export const ASSUMED_ROW_HEIGHT = 40;
export const BORDERS_WIDTH = 2;
